import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Language } from '../../dto/language';
import { AVAILABLE_LOCALES } from '../../tokens';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(@Inject(LOCALE_ID) lang: string, @Inject(AVAILABLE_LOCALES) availableLanguages: string[]) {
    let languageNames = new Intl.DisplayNames([lang], {type: 'language'});
    this.languages = availableLanguages.map(al => new Language(al, languageNames.of(al)!))
   }

   public languages: Language[];
}
